import axios from "axios";
import untils from "@/utils/secret";
import { Message } from "element-ui";

// 开发环境不需要任何域名，会走代理
let baseURL = '/';

// // 发现是NPM RUN BUILD 打包
if (process.env.NODE_ENV.trim() == 'development') {
  // baseURL = 'http://localhost';
  baseURL = 'https://ysgl.hncd.cn';
}
const request = axios.create({
  baseURL: baseURL, //baseURL会自动加在请求地址上 
  timeout: 5000,
});
// 添加请求拦截
request.interceptors.request.use(
  (config) => {
    //在此添加请求做的事-一般可以添加设置token
    // 对请求参数进行统一加密
    console.log("请求的参数------：", config.data);//可测试
    
    // 检查是否是multipart/form-data类型的请求，如果是则跳过加密处理
    const isMultipart = config.headers && config.headers['Content-Type'] && 
                        config.headers['Content-Type'].includes('multipart/form-data');
    
    if (config.data && !isMultipart) {
      config.data = {
        param: untils.encrypt(JSON.stringify(config.data), "3fc17QU4f808be60"),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //请稍后再尝试，也可以自定义错误处理器来捕捉请求失
  }
);
//添加响应拦截 （响应回来还未发送的时候才有用） 这个在操作完成后自动
request.interceptors.response.use(
  (res) => {
    // console.log(res);
    // console.log("原始响应的数据:", res.data); // 添加这一行以检查响应数据或者通过处理

    // 对请求接口进行统一解码,
    // console.log("解密后的数据:", untils.decrypt(res.data, "3fc17QU4f808be60")); // 添加这一行以检查响应数据或者通过处理

    // 原因可能是 后台 接口 返回  无权限操作的时候  没有加密,导致这里解密失败了.做个兼容处理就好了
    let decryptResData;
    if (res.data.sess_id) {
      decryptResData = res.data
    } else {

      decryptResData = JSON.parse(
        untils.decrypt(res.data, "3fc17QU4f808be60")
      );
    }

    if (decryptResData.status !== 1) {
      Message({ message: decryptResData.message || "Error", type: "error" });
      // 未登录 并且 非 开发环境  才 跳转
      //  if (decryptResData.status === -1 && window.location.href.indexOf('localhost') <= -1) {//打包的时候把这行注释掉
      // 未登录状态，跳转到指定链接地址
      if (decryptResData.info && decryptResData.info.goUrl) {
        window.location.href = decryptResData.info.goUrl;
        // }
      }

    }
    // console.log("请求结果：", decryptResData);//可测试

    return Promise.resolve(decryptResData);
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default request;
